<template>
  <div class="changeApply">
    <div class="title">
      金融资质管理 <span>合同修改</span>
    </div>
    <div class="main">
      <div class="changeApplyInfo">合同修改</div>
      <div class="applyContent">
        <div class="applylist">
          <label for="updateImg">
            <span>*</span>修改合同
          </label>
          <div class="ImgContainer">
            <div class="imgItem">
              <div class="imgUrl">
                <img v-if="data.invoiceImg.imgUrl"
                     :src="data.invoiceImg.imgUrl"
                     class="avatar">
              </div>
              <div class="updateImgBtn">上传图片
                <input type="file"
                       @change="handleImgAUpdate"
                       class="updateBtn"
                       accept="image/png,image/jpeg">
              </div>
            </div>
            <p class="pageNum">第一页</p>
          </div>
          <div class="ImgContainer">
            <div class="imgItem">
              <div class="imgUrl">
                <img v-if="data.contractImg.imgUrl"
                     :src="data.contractImg.imgUrl"
                     class="avatar">
              </div>
              <div class="updateImgBtn">上传图片
                <input type="file"
                       @change="handleImgBUpdate"
                       class="updateBtn"
                       accept="image/png,image/jpeg">
              </div>
            </div>
            <p class="pageNum">第二页</p>
          </div>
        </div>

        <div class="applyBtn">
          <button class="save"
                  @click="handleAddApplyClick">
            保存
          </button>
          <button @click="handleCancelClick"
                  class="cancel">
            取消
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { getChangeBankapply, saveChangeBankapply } from 'apis/index'
export default {
  name: 'addapply',
  data () {
    return {
      id: '',
      data: {
        invoiceImg: { imgUrl: '' },
        contractImg: { imgUrl: '' }
      }

    }
  },
  methods: {
    getData (id) { // 获取信息
      getChangeBankapply({
        id: id
      }).then(res => {
        if (res.data.code === 0) {
          // console.log('getChangeBankapply', res)
          this.data = res.data.data.result
        }
      })
    },
    handleImgAUpdate (e) { // 第一张合同
      const MultipartFile = e.target.files[0]
      let param = new FormData()
      param.append('MultipartFile', MultipartFile)
      axios.post('/api/admin/upload.do', param).then(response => {
        this.data.invoiceImg.imgUrl = response.data.url
      })
    },
    handleImgBUpdate (e) { // 第二张合同
      const MultipartFile = e.target.files[0]
      let param = new FormData()
      param.append('MultipartFile', MultipartFile)
      axios.post('/api/admin/upload.do', param).then(response => {
        this.data.contractImg.imgUrl = response.data.url
      })
    },
    handleAddApplyClick () { // 确认
      saveChangeBankapply({
        id: this.id,
        imgUrlA: this.data.invoiceImg.imgUrl,
        imgUrlB: this.data.contractImg.imgUrl
      }).then(res => {
        if (res.data.code === 0) {
          // console.log(res)
          this.$router.push({ path: '/manage/apply' })
        }
      })
    },
    handleCancelClick () { // 取消
      this.$router.push({ path: '/manage/apply' })
    }
  },
  mounted () {
    this.id = this.$route.query.item
    this.getData(this.id)
  }
}
</script>
<style lang="stylus">
.changeApply
  position absolute
  top 0px
  bottom 20px
  left 20px
  right 20px
  z-index 1
  .title
    height 50px
    line-height 50px
    font-size 12px
    color #858C96
    background url('../../../assets/images/01/nav_arrow.png') no-repeat top 21px left 70px #F7F9FB
    span
      color #212832
      margin-left 20px
  .main
    width 100%
    background #fff
    height calc(100% - 50px)
    .changeApplyInfo
      height 46px
      line-height 46px
      padding-left 46px
      color #212832
      background url('../../../assets/images/03/add_icon.png') no-repeat center left 15px
    .applyContent
      width 100%
      height calc(100% - 62px)
      padding-top 14px
      border-top 1px solid #CFD5DC
      border-bottom 1px solid #CFD5DC
      .applylist
        margin-top 26px
        overflow hidden
        label
          width 154px
          float left
          line-height 32px
          text-align right
          font-size 12px
          color #5E656F
          span
            color #FF344A
        .el-input
          width 170px
          margin-left 12px
        .ImgContainer
          width 172px
          overflow hidden
          float left
          margin-left 30px
          .imgItem
            width 172px
            position relative
            overflow hidden
            .imgUrl
              width 172px
              height 186px
              overflow hidden
              img
                width 172px
                position absolute
                top 50%
                left 50%
                transform translate(-50%, -50%)
            .updateImgBtn
              position absolute
              width 172px
              cursor pointer
              background rgba(0, 0, 0, 0.3)
              text-align center
              line-height 32px
              bottom 0px
              left 50%
              transform translate(-50%, 0)
              size12()
              color #FFFFFF
              .updateBtn
                position absolute
                top 0px
                width 172px
                left 0px
                cursor pointer
                opacity 0
                right 0px
                bottom 0px
                overflow hidden
        .pageNum
          width 172px
          height 30px
          text-align center
          line-height 30px
      .applyBtn
        margin-left 164px
        margin-top 74px
        button
          padding 4px 26px
          cursor pointer
          margin 0 20px
          background #FFFFFF
          border-radius 3px
          border 1px solid #CFD5DC
          &:hover
            background #1B88EE
            color #fff
            border 1px solid #1B88EE
</style>
